export default {
    speedOverride_correctedSpeed: 'Velocidad Corregida',
    speedOverride_lastUpdated: 'Última Actualización',
};